import React from 'react';
import {Switch, Route} from 'react-router-dom';
import ContactFormContainer from './form';
import ContactCompleteContainer from './complete';

const ContactContainer = () => {
  return (
    <Switch>
      <Route path="/contact/complete" component={ContactCompleteContainer} />
      <Route path="/contact" component={ContactFormContainer} />
    </Switch>
  );
};

export default ContactContainer;
